import moment from 'moment';
import { ExportService, FILE_TYPE } from "../ExportService";
import { CSV_FILE_PREFIX_MAP } from '../../arsweb/TableTitles';
import { EXPORT_TYPE } from "../../../components/export/ExportModalController";
import {ReactTableController} from '../../../components/tables/reactTableController';
import { FilterUtil } from "../../../components/utils/filtering/FilterUtil";
import { transactionsDownloads, intradaysDownloads, transactionsIndividualDownloads} from '../../arsweb/RoutingPaths';
import { downloadSettingsValueKey } from "fides-angularjs-components/src/fts-administration/fts-exportDownload-settings/fts-download-settings";
import { delimiterOptions } from "fides-angularjs-components/src/fts-administration/fts-exportDownload-settings/fts-export-settings";
import {accountCols} from '../../../components/tables/accounts/accountCols';

/** @ngInject */
export class CSVService extends ExportService {

    constructor(ArsConfig, userService) {

        super(ArsConfig, userService);
        this.csvFileType = FILE_TYPE.CSV; // Default, can be overloaded by ZIP
        this.accountCols = accountCols(userService.fsMainDependencies.$translate);
    }

    downloadZIP(tableController, selectedElements) {
        this.downloadCSV(tableController, selectedElements, FILE_TYPE.ZIP);
    }

    downloadZIP_Xls(tableController, selectedElements) {
        this.downloadXls(tableController, selectedElements, FILE_TYPE.ZIP);
    }

    downloadCSV(tableController, selectedElements, fileType) {
        this.csvFileType = fileType || FILE_TYPE.CSV;
        this.downloadAny(tableController, selectedElements, EXPORT_TYPE.CSV.value);
    }


    downloadXls(tableController, selectedElements, fileType) {
        this.csvFileType = fileType || FILE_TYPE.XLSX;
        this.downloadAny(tableController, selectedElements, EXPORT_TYPE.XLSX.value);
    }

    downloadAny(tableController, selectedElements, fileMime) {
        const tableKey = typeof tableController.getTableKey === "function" ?
            tableController.getTableKey() : tableController.getDataKey();

        const title = tableController.title;
        const cols = tableController instanceof ReactTableController ?
            tableController.getCurrentCols() :
            this.getConfiguredCols(tableController.sessionPersistance,
                tableController.cols.filter(col => (col.type !== 'icon'  && col.type !== 'selection')), tableKey);

        if (!selectedElements) { // Group selection
            this.getTableFilter(tableController, selectedElements);
            this.export(tableController, tableController.restUrl, cols, tableController.modal, title,
                this.csvFileType, fileMime);

            return;
        }

        if (selectedElements.length === 0) {
            tableController.infoPop('NO_ROW_SELECTED');
            return;
        }

        const backendService = tableController.backendService;
        const body = this.constructReportRequest(cols, backendService, title, fileMime);
        this.initReportSelectedIds(tableController, selectedElements, body);
        body.total = selectedElements.length;
        tableController.promise = this.exportFromBankendService(backendService, tableController.reportRestUrl, title, tableController, body);
    }

    initReportSelectedIds(tableController, selectedElements, body) {
        tableController.reportRestUrl = tableController.restUrl;
        if (!this.noLoadKey) {
            this.getTableFilter(tableController, selectedElements);
        } else {
            body.ids = selectedElements;
        }
    }

    getTableFilter(tableController, selectedElements) {
        const filter = tableController.backendService.service.config.params.filter ? tableController.backendService.service.config.params.filter : {};
        if (!selectedElements && filter.loadKey) { // empty prev. row selection
            delete filter.loadKey;
            // group valueseries per account loadkey
			const defaultFilter = FilterUtil.constructFilter([], tableController.$scope);
            if(defaultFilter.loadKey) {
                filter.loadKey = defaultFilter.loadKey;
            }
        } else {
            filter.loadKey = selectedElements;
        }
    }

    getConfiguredCols(sessionPersistance, colsAv, tableKey) {
        return colsAv.map((col) => {
            col.moduleParams = sessionPersistance.get(tableKey + '.' + col.title_key) || { selected: true, position: null };
            return col;
        }).filter(col => col.moduleParams.selected)
            .sort((a, b) => { return a.moduleParams.position - b.moduleParams.position } );
    }

    export(controller, restUrl, tableCols, modal, title, reportType, fileMime) {
        this.csvFileType = reportType;
        const service = this.getService(controller);
		if(controller.masterRowCount) {
			this.total = controller.masterRowCount;
			this.exportAndValidateTotal(controller, restUrl, tableCols, service, fileMime, modal, title);
		}else { // TODO: remove call for old tables
            this.checkTotalElements(service, restUrl).then(() =>
                this.exportAndValidateTotal(controller, restUrl, tableCols, service, fileMime, modal, title));
		}
    }

    exportAndValidateTotal(controller, restUrl, tableCols, service, fileMime, modal, title) {
        const body = this.constructReportRequest(tableCols, service, title, fileMime);
        body.total = controller.masterRowCount;
        //generate from backend and download
        controller.promise = this.exportFromBankendService(service, restUrl, title, controller, body);
    }

    constructReportRequest(tableCols, service, title, fileMime) {
        const userSettings = this.userService.fsMainDependencies.sessionPersistance.get(downloadSettingsValueKey);
        const selectedDelimiter = (userSettings && userSettings.delimiter) ? delimiterOptions.filter(
            delimiter => delimiter.option === userSettings.delimiter) : [delimiterOptions[0]];

        const body = {fileMime: fileMime, delimiter: selectedDelimiter[0].charValue};
        const dateTimePattern = super.getDateTimePattern();
        this.userService.promise.then(this.userService.fsMainDependencies.sessionPersistance.promise.then(()=> {
            body.dateTimePattern = dateTimePattern;
            body.datePattern = dateTimePattern.substring(0, dateTimePattern.indexOf(' '));
            body.numberFormat = this.userService.fsMainDependencies.settings.backendLocaleFormat;
        }));

        if(this.csvFileType.reportType) {
            super.constructReportServiceCall(service, this.csvFileType, body);
            const url = this.csvFileType.reportType.url;
            if(url === transactionsDownloads || url === intradaysDownloads || url === transactionsIndividualDownloads) {
                const cols = this.getTransactionCols(url, this.csvFileType.withStatementData);
                body.headers = cols.map(col => col.title || col.headerName ?
                    col.title || col.headerName : this.$translate.instant(col.title_key));
                body.fields = cols.map(col => col.subfield ? col.field + '_val' : col.field);
            }
        } else {
            const cols = tableCols.filter(col => col.exportable || col.headerName);

            body.headers = cols.map(col => col.title || col.headerName ?
                col.title || col.headerName : this.$translate.instant(col.title_key));
            body.fields = cols.map(col => col.subfield ? col.field + '_val' : col.field);

            // request for CSV groups
            if (this.csvFileType === FILE_TYPE.ZIP) {
                const accColumns = this.accountCols.filter(col => col.exportable);
                body.accHeaders = accColumns.map(col => col.title ? col.title : this.$translate.instant(col.title_key));
                body.accFields = accColumns.map(col => col.subfield ? col.field + '_val' : col.field);
             //  IS NOT USED?? service.service.config.params['accTitle'] = this.$translate.instant(title);

                // Adding group name
                body.accHeaders.splice(0, 0, this.$translate.instant('GROUP_NAME'));
                body.accFields.splice(0, 0, 'groupName');
            }
        }
        return body;
    }

   exportFromBankendService(service, restUrl, title, controller, body) {

        body.title = body.title || this.getFilePrefix(title, controller) + '_' + moment(new Date()).format('DDMMYYYY_HHmm');

       if(_.isNil(restUrl)) {
          restUrl = controller.restUrl
       } else if( this.csvFileType.reportType) {
           restUrl = restUrl + this.csvFileType.reportType.url;
       }

       // the function to call depends if the file is binary (ZIP) or not (CSV): FILE_TYPE
       return service[this.csvFileType.userFunction](restUrl, body)
       .then(data => this.downloadFile(data, body.title, this.csvFileType, controller, service, body, restUrl));
    }
    download(controller, service, body, restUrl){
        return service[this.csvFileType.userFunction](restUrl, body)
            .then(data => this.downloadFile(data, body.title, this.csvFileType, controller, service, body, restUrl))
            .then(() => this.resetFilter(controller));
    }

    getFilePrefix(title, controller) {
        return CSV_FILE_PREFIX_MAP[controller.$scope.predefinedQuery ? controller.$scope.$parent.vm.predefinedQuery.predefinedQuery : title];
    }

    resetFilter(controller) {
        const backendService = this.getService(controller);
        super.resetFilter(controller, backendService);

        const params = backendService.service.config.params;
        delete params['page-index'];
        delete params['page-size'];
        if (params.filter) {
            delete params.filter.loadKey;
        }
    }
}
